import React, { KeyboardEvent } from 'react';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { Popover } from '@milanote/roma';
import { LABEL_NAME_MAX_LENGTH } from '../../../../../../../common/labels/labelConstants';

type Props = {
    value: string;
    onChange: (value: string) => void;
    handleSearchSubmit: () => void;
};

const LabelsSearchBar = ({ value, onChange, handleSearchSubmit }: Props) => {
    const translate = useTranslator('popup', 'labels.search');

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            handleSearchSubmit();
        }
    };

    return (
        <Popover.Header className="LabelSearchBar border-b-0 pb-0">
            <Popover.Search
                aria-label="Enter label name"
                placeholder={translate('placeholder')}
                size="md"
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown}
				maxLength={LABEL_NAME_MAX_LENGTH}
            />
        </Popover.Header>
    );
};

export default LabelsSearchBar;
